// extracted by mini-css-extract-plugin
export var resizer = "_fu-0";